import { Component, input, output } from '@angular/core'

import { TranslatePipe } from '@ngx-translate/core'

@Component({
  selector: 'dhp-filter-items-header',
  templateUrl: './filter-items-header.html',
  imports: [TranslatePipe],
})
export class FilterItemsHeader {
  // The number of items currently selected in the filter.
  selectedCount = input.required<number>()

  // Event emitted when the user clicks the "Clear" button to clear all selected filters.
  clearSelection = output()
}
